import { render, staticRenderFns } from "./AuthVerifyTokenForm.vue?vue&type=template&id=4224da38&scoped=true"
import script from "./AuthVerifyTokenForm.vue?vue&type=script&lang=js"
export * from "./AuthVerifyTokenForm.vue?vue&type=script&lang=js"
import style0 from "./AuthVerifyTokenForm.vue?vue&type=style&index=0&id=4224da38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4224da38",
  null
  
)

export default component.exports